import { Flex, Select } from 'antd';
import React from 'react';

function TemplateSelector({ templates, contactReason, selectedTemplateId, onApplyTemplate }) {
  const matchingTemplates = templates?.filter((t) => t.contact_reason === contactReason) ?? [];
  const otherTemplates = templates?.filter((t) => t.contact_reason !== contactReason) ?? [];

  if (!templates?.length) return null;

  return (
    <Flex align='center' gap={8} className='w-full flex-wrap'>
      <p className='body1 whitespace-nowrap'>Modèle(s) de réponse :</p>
      {matchingTemplates.map((t) => (
        <button type='button' key={t.id} className={`robert-tag${selectedTemplateId === t.id ? ' active' : ''}`} onClick={() => onApplyTemplate(t)}>
          {t.title}
        </button>
      ))}
      {otherTemplates.length > 0 && (
        <Select
          className='body1'
          placeholder='Autre'
          value={undefined}
          style={{ minWidth: 100 }}
          popupMatchSelectWidth={false}
          dropdownStyle={{ minWidth: 250 }}
          onChange={(value) => {
            const t = otherTemplates.find((tmpl) => tmpl.id === value);
            if (t) onApplyTemplate(t, true);
          }}
          options={otherTemplates.map((t) => ({ value: t.id, label: t.title }))}
        />
      )}
    </Flex>
  );
}

export default TemplateSelector;
